<template>
	<div v-if="lawyersOffices == null"></div>
	<BaseCard :title="$t('applied_lawyers_offices').toString()" v-else>
		<div class="flex flex-col mb-10">
			<div>
				<div class="m-4" v-if="this.lawyersOffices && this.lawyersOffices.length <= 0">
					<b>{{ $t('no_available_assessors') }}</b>
				</div>
				<div
					class="align-middle inline-block min-w-full shadow overflow-hidden border-b border-gray-200 rounded"
					v-if="this.lawyersOffices && this.lawyersOffices.length > 0"
				>
					<table class="min-w-full">
						<thead class="w-full" style="height: fit-content;">
							<tr class="w-full">
								<HeaderColumn class="w-2/10" style="width: fit-content">{{ $t('service_provider') }}</HeaderColumn>
								<HeaderColumn class="w-2/10">{{ $t('address') }}</HeaderColumn>
								<HeaderColumn class="w-2/10">{{ $t('phone') }}</HeaderColumn>
								<HeaderColumn class="w-2/10">{{ $t('e_mail') }}</HeaderColumn>
								<HeaderColumn class="w-2/10">{{ $t('status') }}</HeaderColumn>
							</tr>
						</thead>
						<tbody class="bg-white">
							<tr v-for="(lawyerOffice, index) in lawyersOffices" :key="lawyerOffice.id" class="tr odd:bg-gray-200">
								<td class="px-4 py-4 w-3/12" :class="lawyersOffices.length !== index + 1 ? 'border-b border-gray-200' : ''">
									<div v-if="lawyerOffice.firstName">{{ lawyerOffice.firstName }} {{ lawyerOffice.lastName }}</div>
									<div>{{ lawyerOffice.name }}</div>
								</td>
								<td class="py-4 w-3/12" :class="lawyersOffices.length !== index + 1 ? 'border-b border-gray-200' : ''">
									{{ getAddress(lawyerOffice) }},
									{{ lawyerOffice.city.zip_code }}
									{{ lawyerOffice.city.name }}
								</td>
								<td class="py-4 w-1/12" :class="lawyersOffices.length !== index + 1 ? 'border-b border-gray-200' : ''">
									{{ lawyerOffice.phone }}
								</td>
								<td class="py-4 w-3/12" :class="lawyersOffices.length !== index + 1 ? 'border-b border-gray-200' : ''">
									{{ lawyerOffice.email }}
								</td>
								<td class="py-4 w-2/12" :class="lawyersOffices.length !== index + 1 ? 'border-b border-gray-200' : ''">
									{{ $t('account_applied') }}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</BaseCard>
</template>

<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import HeaderColumn from '@/components/columns/HeaderColumn.vue';

export default {
	name: 'ServiceProviderLawyersOfficesApplicationsCard',
	components: { HeaderColumn, BaseCard },
	computed: {
		lawyersOffices() {
			if (this.$store.getters.getLawyerOfficeApplications === undefined || this.$store.getters.getLawyerOfficeApplications.length !== 0) {
				return this.$store.getters.getLawyerOfficeApplications;
			} else {
				return null;
			}
		},
	},
	methods: {
		getAddress(company) {
			if (company.street === undefined || company.street === null) {
				return this.$t('po_box') + ' ' + company.poBox;
			} else {
				if (company.houseNumber != null) {
					return `${company.street} ${company.houseNumber || ''}`;
				} else {
					return company.street;
				}
			}
		},
	},
	mounted() {
		this.$store.dispatch('updateLawyerOfficeApplications');
	},
};
</script>

<style scoped></style>
